(function($) {

    function parallax_section() {
    "use strict";
        var speed1 = 0.15;

        var scrollPosition = $(window).scrollTop();
        var windowHeight = $(window).outerHeight();

        var bannerCount = 0;

        $('.parallax-banner').each(function(){
            bannerCount++;
            var parallaxPosition = 0;
            var backgroundHeight = 0;

            parallaxPosition = $(this).offset().top;
            backgroundHeight = $(this).outerHeight() + (windowHeight * speed1); //* (1 + speed1)

            if (scrollPosition + windowHeight > parallaxPosition && scrollPosition < parallaxPosition + $(".parallax-banner").outerHeight()) {
                var scrollOffset = Math.round((scrollPosition - parallaxPosition) * speed1);
            }

            $(this).children('.image').css({
                'transform':'translate3d(0,' + scrollOffset + 'px,0)',
                'height': backgroundHeight + 'px'
            });
        });

    }

    $(window).on('load', function(){
        if ($('.parallax-banner').length) {
            parallax_section();
        }
    });

    $(window).resize(function(){
        if ($('.parallax-banner').length) {
            parallax_section();
        }
    });

    $(document).scroll(function(){
        if ($('.parallax-banner').length) {
            parallax_section();
        }
});

})( jQuery );
